'use client';

interface FallbackImageProps {
  src: string;
  fallbackSrc: string;
  alt: string;
  className?: string;
}

export function FallbackImage({ src, fallbackSrc, alt, className }: FallbackImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        const img = e.target as HTMLImageElement;
        if (img.src !== fallbackSrc) {
          img.src = fallbackSrc;
        }
      }}
    />
  );
}
